import "react";
import { createSafeContext } from "./auth-service-tools176.js";
import "./auth-service-tools177.js";
const [ComboboxProvider, useComboboxContext] = createSafeContext("Combobox component was not found in tree");
export { ComboboxProvider, useComboboxContext };